import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import {
	DriverType,
	VehicleType,
	RegistrationState,
	AccountType
} from "./types";

const initialState = {
	step: 1,
	data: {
		id: "",
		name: "",
		email: "",
		password: "",
		document: "",
		cellphone: "",
		vehicles: [],
		drivers: [],
		accounts: []
	}
} as RegistrationState;

const registrationSlice = createSlice({
	name: "registration",
	initialState,
	reducers: {
		setStep(state, action: PayloadAction<number>) {
			state.step = action.payload;
		},
		setInitialPersonalInformation: (
			state,
			action: PayloadAction<RegistrationState>
		) => {
			state.data.id = action.payload.data.id;
			state.data.name = action.payload.data.name;
			state.data.email = action.payload.data.email;
			state.data.password = action.payload.data.password;
			state.data.document = action.payload.data.document;
			state.data.cellphone = action.payload.data.cellphone;
		},
		setPersonalInfo(
			state,
			action: PayloadAction<Partial<RegistrationState["data"]>>
		) {
			state.data = { ...state.data, ...action.payload };
		},

		addVehicle(state, action: PayloadAction<VehicleType>) {
			state.data.vehicles.push(action.payload);
		},
		updateVehicle(state, action: PayloadAction<VehicleType>) {
			const index = state.data.vehicles.findIndex(
				(v) => v.id === action.payload.id
			);
			if (index !== -1) {
				state.data.vehicles[index] = action.payload;
			}
		},
		removeVehicle(state, action: PayloadAction<string>) {
			state.data.vehicles = state.data.vehicles.filter(
				(v) => v.id !== action.payload
			);
		},
		addDriver(state, action: PayloadAction<DriverType>) {
			state.data.drivers.push(action.payload);
		},
		updateDriver(state, action: PayloadAction<DriverType>) {
			const index = state.data.drivers.findIndex(
				(d) => d.id === action.payload.id
			);
			if (index !== -1) {
				state.data.drivers[index] = action.payload;
			}
		},
		removeDriver(state, action: PayloadAction<string>) {
			state.data.drivers = state.data.drivers.filter(
				(d) => d.id !== action.payload
			);
		},
		addAccount(state, action: PayloadAction<AccountType>) {
			state.data.accounts.push(action.payload);
		},
		updateAccount(state, action: PayloadAction<AccountType>) {
			const index = state.data.accounts.findIndex(
				(a) => a.id === action.payload.id
			);
			if (index !== -1) {
				state.data.accounts[index] = action.payload;
			}
		},
		removeAccount(state, action: PayloadAction<string>) {
			state.data.accounts = state.data.accounts.filter(
				(a) => a.id !== action.payload
			);
		},
		resetRegistration(state) {
			Object.assign(state, initialState);
		}
	}
});

export const {
	setStep,
	setPersonalInfo,
	addVehicle,
	updateVehicle,
	removeVehicle,
	addDriver,
	updateDriver,
	removeDriver,
	addAccount,
	updateAccount,
	removeAccount,
	resetRegistration
} = registrationSlice.actions;
export default registrationSlice.reducer;
